type CacheEntry<T> = {
  value: T;
  expiresAt: number;
};

const inFlight = new Map<string, Promise<unknown>>();
const resultCache = new Map<string, CacheEntry<unknown>>();

export function dedupedRequest<T>(
  key: string,
  fetcher: () => Promise<T>,
  staleTimeMs = 0
): Promise<T> {
  const now = Date.now();
  const cached = resultCache.get(key);
  if (cached && cached.expiresAt > now) {
    return Promise.resolve(cached.value as T);
  }

  const pending = inFlight.get(key);
  if (pending) {
    return pending as Promise<T>;
  }

  const promise = fetcher()
    .then((value) => {
      if (staleTimeMs > 0) {
        resultCache.set(key, { value, expiresAt: Date.now() + staleTimeMs });
      }
      return value;
    })
    .finally(() => {
      inFlight.delete(key);
    });

  inFlight.set(key, promise);
  return promise;
}

export function invalidateDedupedRequest(key: string): void {
  inFlight.delete(key);
  resultCache.delete(key);
}

export function clearDedupedRequests(): void {
  inFlight.clear();
  resultCache.clear();
}
